import { sendAdminRequest } from '../../api/websocketApi';
import useStore from '../../store/store';

export interface UpdateMemberParams {
    memberId: number;
    firstName?: string;
    lastName?: string;
    sex?: 'male' | 'female';
    birthDate?: Date;
    patientId?: string | null;
    referringPhysician?: string | null;
    ethnicity?: string | null;
}

interface APIResponse {
    success: boolean;
    errCode?:
        | 'invalid_param'
        | 'invalid_token'
        | 'auth_failed'
        | 'access_denied';
    errDetails?: string;
}

const UpdateMember = (params: UpdateMemberParams) => {
    const setFormError = useStore.getState().setFormError;
    const setIsLoading = useStore.getState().setIsLoading;

    setIsLoading(true);
    sendAdminRequest(
        {
            endpoint: '/member/update',
            body: params,
        },
        (data: APIResponse) => {
            const { success, errCode, errDetails } = data;
            if (success) {
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default UpdateMember;
